module.exports = __webpack_public_path__ + "img/filters.f0f4af43.png";